























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import { PropSync } from 'vue-property-decorator'

@Component({
  components: {
    Radio
  }
})
export default class PanelContentItemContentTypeRadio extends Vue {
  @PropSync('aiType', { type: Boolean }) syncedAiType!: boolean

  contentOptions: {
    img: string
    icon: string
    title: string
    label: string
    desc: string
    color: string
    value: boolean
  }[] = [
    {
      img: 'dart',
      icon: 'writing',
      title: 'حرفه‌ای',
      label: 'تولید محتوا توسط نویسندگان',
      desc: 'تولید محتوا توسط نویسندگان حرفه‌ای نیک‌نویس',
      color: '#009E83',
      value: false
    },
    {
      img: 'fast',
      icon: 'ai-content',
      title: 'سریع و به‌صرفه',
      label: 'تولید محتوا با هوش مصنوعی',
      desc: 'تحویل سریع با حساسیت ویراستاران نیک‌نویس',
      color: '#7B47BD',
      value: true
    }
  ]

  get getContentOptions() {
    return this.contentOptions
  }
}
